import React, { useEffect,  useRef, useState } from "react";

import { Row, Col, Button, Offcanvas, Table } from "react-bootstrap";
import ColourFilterBox from "../../../../components/FilterBox/ColourFilter/ColourFilter";
import ColourParentChild from "../../../../components/Tables/ColourParentChild";
import Chart from "../../../../components/Charts/Chart";
import { FiMenu } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";

import { format } from "date-fns";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import ColourTable from "../../../../components/Tables/ColourTable";
import ColourChart from "../../../../components/Charts/ColourChart";
import {
  ColorMasterGrpProdAndCostTable,
  ColorMasterGrpProdAndCostTableFun,
  ColourFilter,
} from "../../../../Redux/Slice/Colour/InwardAnylysis/InwardAnylysis";
import { Loader } from "../../../../components/Loader/Loader";
import Calendar from "react-calendar";
import { useTheme } from "../../../../Themecontext/Themecontext";
import ColorCalenderCss from "../../../../components/Calendar/ColorCalenderCss";

export const MachineGroupMachineCosting = () => {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { ColourfilterData, ColorMasterGrpProdAndCostTableData } = useSelector(
    (state) => state.InwardAnylysisSlice,
  );
  const iscolour = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICL",
  );
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWCOLOURCHEMICLDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [showFilter, setShowFilter] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return "";
    return format(new Date(date), "yyyy-MM-dd");
  };
  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  // 🔷 State
  const [filters, setFilters] = useState({
    productionGroup: [],
    machineGroup: [],
  });

  const [search, setSearch] = useState({
    productionGroup: "",
    machineGroup: "",
  });

  useEffect(() => {
    if (!startDate || !endDate) return;
    dispatch(ColourFilter());
    dispatch(
      ColorMasterGrpProdAndCostTable({
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
      }),
    );
  }, [dispatch, Firm, FinancialYear, startDate, endDate]);

  const productionGroupList = ColourfilterData?.ProductionGroup?.map(
    (item) => ({
      label: item?.ProductionGroupMstName,
      value: item?.ProductionGroupMstID,
    }),
  );

  const machineGroupList = ColourfilterData?.MachineGroup?.map((item) => ({
    label: item?.MachineGroupMstName,
    value: item?.MachineGroupMstID,
  }));

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      const selected = prev[type];
      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };

  const selectAll = (type, items) => {
    const allIds = items.map((i) => i.value);
    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === items.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, val) => {
    setSearch((prev) => ({ ...prev, [type]: val }));
  };

  // 🔷 CHART DATA (separate)
  const summary = ColorMasterGrpProdAndCostTableData?.Summary || [];

  const chartData =
    (ColorMasterGrpProdAndCostTableData?.Summary || []).map((item) => ({
      MachineGroupMstName:
        item?.MachineGroupMstName ||
        item?.machinegroupmstname ||
        "",

      CostAmount:
        Number(item?.CostAmount || item?.costAmount || 0),
    }));
    
  const columns = [
    {
      label: "Machine Group",
      key: "MachineGroupMstName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Machine Name",
      key: "MachineMstName",
      left: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    {
      label: "Consumption Amount",
      key: "CostAmount",
      align: "right",
      format: "true",
    },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    {
      label: "Final Meter",
      key: "FinalPrdMtr",
      align: "right",
      format: "true",
    },
    {
      label: "Cost Per Meter",
      key: "PMeterCost",
      align: "right",
      format: "true",
    },
  ];

  const rows = (ColorMasterGrpProdAndCostTableData?.Detail || [])?.map(
    (row) => ({
      MachineMstID: row.MachineMstID || "",
      MachineGroupMstName: row.MachineGroupMstName || "",
      MachineMstName: row.MachineMstName || "",
      Meter: row.Meter || "",
      CostAmount: row.CostAmount || "",
      FinalPrdMtr: row.FinalPrdMtr || "",
      PMeterCost: row.PMeterCost || "",
    }),
  );

  const TableChartColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Machine Group", key: "MachineGroupMstName", align: "left", colors: isdark === "light" ? "#000" : "#fff", },
    { label: "Meter", key: "Meter", align: "right", format: "true" },
    {
      label: "Consumption Amount",
      key: "CostAmount",
      align: "right",
      format: "true",
    },
    {
      label: " Cost Per Meter ",
      key: "PMeterCost",
      align: "right",
      format: "true",
    },
  ];

  const TableChartRow = (ColorMasterGrpProdAndCostTableData?.Summary || []).map(
    (row) => {
      return {
        MachineGroupMstName: row.machinegroupmstname || "",
        Meter: row.meter || "",
        CostAmount: row.costAmount || "",
        PMeterCost: row.PMeterCost || "",
      };
    },
  );

  const handleApply = () => {
    dispatch(ColorMasterGrpProdAndCostTableFun());
    dispatch(
      ColorMasterGrpProdAndCostTable({
        StartDate: safeFormat(startDate),
        EndDate: safeFormat(endDate),
        FirmIDs: Firm,
        AcYearIDs: FinancialYear,
        ProductionGroupIDs: (filters.productionGroup || []).join(","),
        MachineIDs: (filters.machineGroup || []).join(","),
      }),
    );

    setShowFilter(false);
  };

  if (!ColourfilterData) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  if (
    !ColorMasterGrpProdAndCostTableData ||
    ColorMasterGrpProdAndCostTableData === "no"
  ) {
    return (
      <div className="flex justify-center items-center h-screen">
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        background:
          isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,
        minHeight: "100vh",
        padding: "16px",
      }}
    >
      {/* MOBILE */}
      <div className="d-lg-none text-end mb-2">
        <Button
          onClick={() => setShowFilter(true)}
          style={{
            background:
              isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour7,
            border: "none",
          }}
        >
          <FiMenu />
        </Button>
      </div>

      <Offcanvas show={showFilter} onHide={() => setShowFilter(false)}
        style={{
          background:
            isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour4,

        }}
      >
        <Offcanvas.Header closeButton
          closeVariant={isdark === "dark" ? "white" : undefined}
          style={{ color: isdark === "light" ? "#000" : "#FFF", }}
        >
          <Offcanvas.Title>Filters</Offcanvas.Title>
        </Offcanvas.Header>

        <Offcanvas.Body>
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* DATE PICKER */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#fff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            <ColourFilterBox
              title="Production Group "
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(v) => handleSearch("productionGroup", v)}
              selectedItems={filters.productionGroup}
              toggleItem={(i) => toggleItem("productionGroup", i)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <ColourFilterBox
              title="Machine Group"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(v) => handleSearch("machineGroup", v)}
              selectedItems={filters.machineGroup}
              toggleItem={(i) => toggleItem("machineGroup", i)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />

            <Button
              onClick={handleApply}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
            >
              Apply Filters
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <Row>
        {/* DESKTOP FILTER */}
        <Col xl={3} lg={4} className="d-none d-lg-block">
          <div
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            {/* DATE PICKER */}
            <div>
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour6
                      : iscolourDark?.Colour7,
                  padding: "13px 20px",
                  borderRadius: "12px 12px 0px 0px",
                }}
              >
                <h3
                  style={{
                    fontWeight: "700",
                    fontSize: "18px",
                    margin: 0,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour12
                        : iscolourDark?.Colour12,
                    alignItems: "center",
                    display: "flex",
                  }}
                >
                  {" "}
                  Date Range
                </h3>
              </div>
              <div
                style={{
                  border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                  padding: "15px",
                  marginBottom: "15px",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour3,
                  borderRadius: "0px 0px 12px 12px",
                }}
              >
                <div
                  onClick={() => setShowDatePicker(true)}
                  style={{
                    marginTop: "8px",
                    padding: "10px",
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour6}`,
                    borderRadius: "10px",
                    cursor: "pointer",
                    textAlign: "center",
                    color: isdark === "light" ? "#000" : "#ffff",
                  }}
                >
                  {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                    ? `${format(dateRange[0].startDate, "yyyy-MM-dd")} - ${format(dateRange[0].endDate, "yyyy-MM-dd")}`
                    : "Select Date Range"}
                </div>
              </div>
            </div>

            <ColourFilterBox
              title="Production Group "
              items={productionGroupList}
              search={search.productionGroup}
              setSearch={(v) => handleSearch("productionGroup", v)}
              selectedItems={filters.productionGroup}
              toggleItem={(i) => toggleItem("productionGroup", i)}
              selectAll={() =>
                selectAll("productionGroup", productionGroupList)
              }
            />

            <ColourFilterBox
              title="Machine Group"
              items={machineGroupList}
              search={search.machineGroup}
              setSearch={(v) => handleSearch("machineGroup", v)}
              selectedItems={filters.machineGroup}
              toggleItem={(i) => toggleItem("machineGroup", i)}
              selectAll={() => selectAll("machineGroup", machineGroupList)}
            />

            <Button
              onClick={handleApply}
              style={{
                width: "100%",
                height: "44px",
                borderRadius: "10px",
                backgroundColor:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color:
                  isdark === "light"
                    ? iscolour?.Colour1
                    : iscolourDark?.Colour12,
                border: "none",
                fontWeight: "700",
                padding: "12px"
              }}
            >
              Apply Filters
            </Button>
          </div>
        </Col>

        {/* CONTENT */}
        <Col xl={9} lg={8}>
          {/* 🔥 CHART BOX */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MACHINE COST CHART
            </div>

            <div>
              <ColourChart
                data={chartData}
                labelKey="MachineGroupMstName"
                valueKey="CostAmount"
              />
            </div>
          </div>

          {/* 🔥 PARENT CHILD TABLE WITH HEADING */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MACHINE GROUPWISE DETAIL
            </div>

            <ColourTable columns={TableChartColumns} data={TableChartRow} />
          </div>

          {/* 🔥 NORMAL TABLE */}
          <div
            style={{
              borderRadius: "14px",
              overflow: "hidden",
              marginTop: "20px",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
            }}
          >
            <div
              style={{
                padding: "14px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour6
                    : iscolourDark?.Colour7,
                color: "#fff",
                fontWeight: "600",
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
              }}
            >
              MACHINE SUMMARY
            </div>

            <ColourParentChild
              columns={columns}
              data={rows}
              parentKey="MachineGroupMstName"
            />
          </div>
        </Col>
      </Row>

      {/* DATE PICKER */}
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <ColorCalenderCss
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,

              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour7
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MachineGroupMachineCosting;
